import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { LanguageConsumer } from '../../state'

const getPublisher = (key, publishers) =>
  publishers.nodes.filter(
    (publisher) => publisher.childMarkdownRemark.frontmatter.key === key
  )[0].childMarkdownRemark.frontmatter

const Query = ({ render }) => (
  <LanguageConsumer>
    {({ lang }) => (
      <StaticQuery
        query={graphql`
          query {
            allContent: allFile(
              filter: { relativePath: { glob: "content/pages/press/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    content {
                      title
                      twitter_timeline
                      view_more
                    }
                  }
                }
              }
            }

            articles: allFile(
              filter: { relativePath: { glob: "content/press-articles/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    publisher
                    publish_date
                    author
                    localized {
                      href
                      lang
                      title
                    }
                  }
                }
              }
            }

            publishers: allFile(
              filter: {
                relativePath: { glob: "content/press-publishers/*.md" }
              }
            ) {
              nodes {
                childMarkdownRemark {
                  frontmatter {
                    title
                    key
                    thumbnail
                  }
                }
              }
            }
          }
        `}
        render={({ allContent, articles, publishers }) => {
          const content = allContent.nodes
            .filter(
              (node) =>
                node.relativePath === `content/pages/press/press-${lang}.md`
            )
            .shift()
          if (!content || !content.childMarkdownRemark)
            throw new Error(`No press translations found for language ${lang}`)
          const localizedArticles = articles.nodes.map((node) => {
            const localizedContent =
              node.childMarkdownRemark.frontmatter.localized.filter(
                (local) => local.lang === lang
              )[0] ||
              node.childMarkdownRemark.frontmatter.localized.filter(
                (local) => local.lang === 'en'
              )[0]

            if (!localizedContent) return
            const publisher = getPublisher(
              node.childMarkdownRemark.frontmatter.publisher,
              publishers
            )
            return {
              ...node.childMarkdownRemark.frontmatter,
              publisher: publisher.title,
              thumbnail: publisher.thumbnail,
              content: {
                ...localizedContent
              }
            }
          })

          localizedArticles.sort((a, b) => {
            const dateA = new Date(a.publish_date)
            const dateB = new Date(b.publish_date)
            if (dateA > dateB) return -1
            if (dateA < dateB) return 1
            if (a.publisher.toLowerCase() > b.publisher.toLowerCase()) return -1
            if (a.publisher.toLowerCase() < b.publisher.toLowerCase()) return 1
            return 0
          })

          return render({
            content: content.childMarkdownRemark.frontmatter.content,
            articles: localizedArticles
          })
        }}
      />
    )}
  </LanguageConsumer>
)

Query.propTypes = {
  render: PropTypes.func.isRequired
}

export default Query
